<template>
  <el-container>
    <el-row type="flex" justify="center">
      <el-col :span="15">
        <!-- Logo上传 -->
        <div class="block">
          <h5>Logo上传</h5>
          <el-upload
            class="upload-demo"
            ref="upload"
            :auto-upload="false"
            @change="handleFileChange"
            :before-upload="beforeUploadImage"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">选取图片</el-button>
          </el-upload>
          <el-button
            size="small"
            type="success"
            @click="submitImage"
            :loading="loadingImage"
            style="margin-left: 10px;"
          >提交</el-button>
        </div>

        <!-- 名称配置 -->
        <div class="block">
          <h5>名称配置</h5>
          <el-form @submit.prevent="submitTitle">
            <el-form-item>
              <el-input v-model="title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" native-type="submit" :loading="loadingTitle">提交</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 模板上传区域 -->
        <div class="block" v-for="(uploadConfig, index) in uploadConfigs" :key="`upload-${index}`">
          <h5>{{ uploadConfig.label }}</h5>
          <el-upload
            class="upload-demo"
            :ref="`upload${index}`"
            :auto-upload="false"
            @change="(file) => handleTemplateChange(file, uploadConfig.type)"
            :before-upload="beforeUploadTemplate"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">选取文件</el-button>
          </el-upload>
          <el-button
            size="small"
            type="success"
            @click="() => submitTemplate(uploadConfig.type)"
            :loading="loadingTemplate[uploadConfig.type]"
            style="margin-left: 10px;"
          >提交</el-button>
        </div>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';

export default {
  setup() {
    const loadingImage = ref(false);
    const loadingTitle = ref(false);
    const title = ref('');
    const imageFile = ref(null);
    const templateFiles = ref({});
    const loadingTemplate = ref({
      School_Course_Summary: false,
      School_Preparation_Summary: false,
      School_Lecture: false,
      Internship_Certificate: false,
    });

    const uploadConfigs = [
      { label: '校级开课汇总模板', type: 'School_Course_Summary' },
      { label: '校级主备汇总模板', type: 'School_Preparation_Summary' },
      { label: '校级讲座模板', type: 'School_Lecture' },
      { label: '跟岗汇总模板', type: 'Internship_Certificate' },
    ];

    const handleFileChange = (file) => {
      imageFile.value = file.raw;
    };

    const handleTemplateChange = (file, type) => {
      templateFiles.value[type] = file.raw;
    };

    const beforeUploadImage = (file) => {
      const isImage = file.type.includes('image/');
      if (!isImage) {
        ElMessage.error('只能上传图片文件');
        return false;
      }
      return true;
    };

    const beforeUploadTemplate = (file) => {
      const isDocx = file.name.endsWith('.docx');
      if (!isDocx) {
        ElMessage.error('只能上传.docx文件');
        return false;
      }
      return true;
    };

    const submitImage = async () => {
      if (!imageFile.value) {
        ElMessage.error('请先选择一个图片文件');
        return;
      }
      const formData = new FormData();
      formData.append('logo', imageFile.value);

      try {
        loadingImage.value = true;
        await axios.post('/api/upload-logo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        ElMessage.success('图片上传成功');
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '图片上传失败');
      } finally {
        loadingImage.value = false;
      }
    };

    const submitTitle = async () => {
      if (!title.value) {
        ElMessage.error('标题不能为空');
        return;
      }
      try {
        loadingTitle.value = true;
        await axios.post('/api/update-title', {
          name: 'title',
          value: title.value,
        });
        ElMessage.success('标题更新成功');
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '标题更新失败');
      } finally {
        loadingTitle.value = false;
      }
    };

    const submitTemplate = async (type) => {
      if (!templateFiles.value[type]) {
        ElMessage.error('请先选择一个文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', templateFiles.value[type]);

      try {
        loadingTemplate.value[type] = true;
        await axios.post(`/api/upload-template/${type}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        ElMessage.success('文件上传成功');
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '文件上传失败');
      } finally {
        loadingTemplate.value[type] = false;
      }
    };

    return {
      loadingImage,
      loadingTitle,
      title,
      submitImage,
      submitTitle,
      handleFileChange,
      handleTemplateChange,
      beforeUploadImage,
      beforeUploadTemplate,
      uploadConfigs,
      submitTemplate,
      loadingTemplate,
    };
  },
};
</script>

<style>
.block {
  margin-bottom: 20px; /* 增加区块间距离 */
}
</style>